// src/components/BadgeSottoattivita.js
// Indicatore delle sottoattività accanto al nome dell'attività (stile Asana, ottobre 2026):
// «⑂ 2/5» = completate / totali, verde quando sono tutte completate. Nell'elenco della
// commessa è anche il pulsante che le apre sotto la riga; nel Kanban è solo indicatore.
import React from "react";
import { contaSottoattivita } from "../utils/sottoattivitaElenco";

export default function BadgeSottoattivita({ lista, aperto = null, onClick = null }) {
  const { fatte, totali } = contaSottoattivita(lista);
  if (!totali) return null;
  const tutte = fatte === totali;
  return (
    <span onClick={onClick ? e => { e.stopPropagation(); onClick(); } : undefined}
      title={`${totali === 1 ? "1 sottoattività" : `${totali} sottoattività`}, ${fatte} completate${onClick ? (aperto ? " · clicca per chiudere" : " · clicca per vederle") : ""}`}
      style={{ display:"inline-flex", alignItems:"center", gap:3, flexShrink:0, fontSize:11.5, fontWeight:600, lineHeight:1,
        padding:"3px 6px", borderRadius:10, cursor: onClick ? "pointer" : "default", userSelect:"none",
        color: tutte ? "#047857" : "#6b7280", background: tutte ? "#ecfdf5" : aperto ? "#ede9fe" : "#f3f4f6",
        border: `1px solid ${tutte ? "#a7f3d0" : aperto ? "#c4b5fd" : "#e5e7eb"}` }}>
      <svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="3" cy="2.5" r="1.5"/><circle cx="9" cy="9.5" r="1.5"/><path d="M3 4v3.5a2 2 0 0 0 2 2h2.5"/>
      </svg>
      {fatte}/{totali}
    </span>
  );
}

